import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';
import { logout } from '../features/loginSlice';
import Cookies from 'js-cookie';
import api from '../services/api';


const IdleChecker = ({ children }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const onIdle = async () => {
        try {
            const refreshToken = Cookies.get('refreshToken');
            if (refreshToken) {
                await api.post('/auth/logout', { refreshToken });
            }
        } catch (e) {
            // proceed with local logout even if backend call fails
        } finally {
            Cookies.remove('jwt');
            Cookies.remove('refreshToken');
            Cookies.remove('userRole');
            Cookies.remove('healthFacility');
            dispatch(logout());
            navigate('/');
        }
    };

    const { getRemainingTime } = useIdleTimer({
        onIdle,
        timeout: 1000 * 60 * 10, // 10 minutes in milliseconds
        throttle: 500 // Check every 500ms
        });

  return children;
};

export default IdleChecker;